import React, { useState } from 'react';
import { UploadIcon, ImageIcon, AlertCircleIcon, InfoIcon } from 'lucide-react';
export const FoundationalSettings = () => {
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  return <>
      {/* Basic Information Section */}
      <div className="border-b border-gray-200 pb-8" data-id="element-1051">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1052">
          Basic Information
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1053">
          <div data-id="element-1054">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1055">
              System Name*
            </label>
            <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="e.g. Municipal Management System" data-id="element-1056" />
          </div>
          <div data-id="element-1057">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1058">
              Organization Name*
            </label>
            <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="e.g. Addis Ababa City Administration" data-id="element-1059" />
          </div>
        </div>
        <div className="mt-6" data-id="element-1060">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1061">
            Organization Address*
          </label>
          <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Street Address" data-id="element-1062" />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-1063">
            <input type="text" className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="City" data-id="element-1064" />
            <input type="text" className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Region" data-id="element-1065" />
            <input type="text" className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Postal Code" data-id="element-1066" />
          </div>
        </div>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1067">
          <div data-id="element-1068">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1069">
              Contact Email*
            </label>
            <input type="email" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="contact@organization.gov.et" data-id="element-1070" />
          </div>
          <div data-id="element-1071">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1072">
              Contact Phone*
            </label>
            <input type="tel" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="+251 XX XXX XXXX" data-id="element-1073" />
          </div>
        </div>
      </div>
      {/* Logo Upload Section */}
      <div className="border-b border-gray-200 py-8" data-id="element-1074">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1075">
          Logo & Branding
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1076">
          <div data-id="element-1077">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1078">
              Organization Logo*
            </label>
            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md hover:border-gray-400 transition-colors duration-150" data-id="element-1079">
              <div className="space-y-1 text-center" data-id="element-1080">
                <div className="flex flex-col items-center" data-id="element-1081">
                  <UploadIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-1082" />
                  <div className="flex text-sm text-gray-600" data-id="element-1083">
                    <label htmlFor="logo-upload" className="relative cursor-pointer bg-white rounded-md font-medium text-blue-600 hover:text-blue-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-blue-500" data-id="element-1084">
                      <span data-id="element-1085">Upload a file</span>
                      <input id="logo-upload" name="logo-upload" type="file" className="sr-only" accept="image/*" data-id="element-1086" />
                    </label>
                    <p className="pl-1" data-id="element-1087">or drag and drop</p>
                  </div>
                  <p className="text-xs text-gray-500" data-id="element-1088">
                    PNG, JPG, GIF up to 10MB
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div data-id="element-1089">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1090">
              Preview
            </label>
            <div className="mt-1 flex justify-center px-6 py-6 border border-gray-300 rounded-md bg-gray-50" data-id="element-1091">
              <div className="text-center" data-id="element-1092">
                <ImageIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-1093" />
                <p className="mt-1 text-sm text-gray-500" data-id="element-1094">No logo uploaded</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Regional Settings */}
      <div className="border-b border-gray-200 py-8" data-id="element-1095">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1096">
          Regional Settings
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1097">
          <div data-id="element-1098">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1099">
              Default Country Code*
            </label>
            <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1100">
              <option value="ET" data-id="element-1101">Ethiopia (ET)</option>
              <option value="KE" data-id="element-1102">Kenya (KE)</option>
              <option value="UG" data-id="element-1103">Uganda (UG)</option>
            </select>
          </div>
          <div data-id="element-1104">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1105">
              Default Currency Code*
            </label>
            <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1106">
              <option value="ETB" data-id="element-1107">Ethiopian Birr (ETB)</option>
              <option value="USD" data-id="element-1108">US Dollar (USD)</option>
              <option value="EUR" data-id="element-1109">Euro (EUR)</option>
            </select>
          </div>
          <div data-id="element-1110">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1111">
              Currency Symbol
            </label>
            <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="ETB" maxLength={4} data-id="element-1112" />
          </div>
        </div>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1113">
          <div data-id="element-1114">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1115">
              Fiscal Year Start*
            </label>
            <div className="grid grid-cols-2 gap-4" data-id="element-1116">
              <select className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1117">
                <option value="" data-id="element-1118">Select Month</option>
                <option value="1" data-id="element-1119">January</option>
                <option value="7" data-id="element-1120">July</option>
                <option value="9" data-id="element-1121">September</option>
              </select>
              <select className="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1122">
                <option value="" data-id="element-1123">Select Day</option>
                <option value="1" data-id="element-1124">1</option>
                <option value="7" data-id="element-1125">7</option>
                <option value="8" data-id="element-1126">8</option>
              </select>
            </div>
          </div>
          <div data-id="element-1127">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1128">
              System Primary Timezone*
            </label>
            <select className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1129">
              <option value="EAT" data-id="element-1130">East Africa Time (UTC+3)</option>
              <option value="CAT" data-id="element-1131">Central Africa Time (UTC+2)</option>
              <option value="WAT" data-id="element-1132">West Africa Time (UTC+1)</option>
            </select>
          </div>
        </div>
      </div>
      {/* System Configuration */}
      <div className="pt-8" data-id="element-1133">
        <h3 className="text-base font-semibold text-gray-900 mb-6" data-id="element-1134">
          System Configuration
        </h3>
        <div className="space-y-6" data-id="element-1135">
          <div className="flex items-center justify-between p-4 border border-gray-200 rounded-md" data-id="element-1136">
            <div data-id="element-1137">
              <h4 className="text-sm font-medium text-gray-900" data-id="element-1138">
                Maintenance Mode
              </h4>
              <p className="text-sm text-gray-500 mt-1" data-id="element-1139">
                Enable maintenance mode to prevent user access during system
                updates
              </p>
            </div>
            <div className="flex items-center" data-id="element-1140">
              <button onClick={() => setMaintenanceMode(!maintenanceMode)} className={`relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 ${maintenanceMode ? 'bg-blue-600' : 'bg-gray-200'}`} role="switch" aria-checked={maintenanceMode} data-id="element-1141">
                <span aria-hidden="true" className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out ${maintenanceMode ? 'translate-x-5' : 'translate-x-0'}`} data-id="element-1142" />
              </button>
            </div>
          </div>
          {maintenanceMode && <div className="p-4 border border-gray-200 rounded-md" data-id="element-1143">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1144">
                Maintenance Mode Message
              </label>
              <textarea rows={3} className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Enter the message to display during maintenance..." data-id="element-1145" />
              <p className="mt-2 text-sm text-gray-500 flex items-center" data-id="element-1146">
                <InfoIcon className="h-4 w-4 mr-1" data-id="element-1147" />
                This message will be displayed to users when they try to access
                the system
              </p>
            </div>}
        </div>
      </div>
    </>;
};